var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-main" }, [
    _c(
      "main",
      {
        staticClass: "main--login",
        attrs: { id: "main", "data-page-id": "login" }
      },
      [
        _c(
          "section",
          { staticClass: "section-login" },
          [
            _c("Header", { attrs: { "is-whitelabel": _vm.isWhitelabel } }),
            _vm._v(" "),
            _c("div", { staticClass: "login-form-wrapper" }, [
              _c(
                "div",
                { staticClass: "loginv2-container p-b-20" },
                [
                  !_vm.displayRequireTwoFactorAuthConfig
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", {
                          staticClass: "login_logo",
                          class: { "login_logo--ringba": !_vm.isWhitelabel },
                          attrs: { "data-testid": "login-logo" }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.twoFactorAuthRequired &&
                  !_vm.displayRequireTwoFactorAuthConfig &&
                  !_vm.isTransitionPending
                    ? _c("LoginForm", {
                        attrs: { "action-status": _vm.actionStatus },
                        on: { login: _vm.onLogin }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.twoFactorAuthRequired &&
                  !_vm.displayRequireTwoFactorAuthConfig
                    ? _c("TwoFactorForm", {
                        attrs: {
                          "back-button-description": "BACK_LOGIN_LINK",
                          "action-status": _vm.twoFactorActionStatus,
                          "can-remember-device": true
                        },
                        on: { "two-factor-verify": _vm.onLoginTwoFactor }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.displayRequireTwoFactorAuthConfig
                    ? _c("TwoFactorAuthMFAForm", {
                        attrs: {
                          "is-login-flow": true,
                          "enforce-mfa": _vm.enforceMfa
                        },
                        on: { "redirect-to-dashboard": _vm.redirectToDashboard }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isWhitelabel ? _c("Footer") : _vm._e(),
        _vm._v(" "),
        _vm.isWhitelabel ? _c("WhitelabelFooter") : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }